<template>

  <m-card517 :image="content.thumbnail" :alt="content.title">

    <div class="card-body bg-primary mt-2">

      <div class="title-card  ">
        <a class="card-text  font-weight-bold text-dark" :href="findLinkOnContent(content.abstraction)">{{ contentSlicer(content.title,40) }}</a>
      </div>

      <div class="description-card mt-3 ">
        <p class="card-text  font-weight-light text-dark">
          <a class="text-dark " :href="findLinkOnContent(content.abstraction)" v-html="contentSlicer(content.body,60)"></a>
        </p>

      </div>
      <div class="button-card mt-3 show-button-content-501 font-weight-bold">

        <div class="d-flex align-items-center">
          <span v-t="`content.card.more`" class="button-card-502"> </span><i class="bi bi-arrow-left-short mt-2 px-3 text-dark icon-show-content "></i>
        </div>

      </div>


    </div>


  </m-card517>


</template>

<script>
import {CardComputed} from "./CardComputed";
import mCard517 from "../../Cards/Card517";
import mA from '../../Tags/A'
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";


export default {
  name: "ContentCard501",
  methods: {contentSlicer},
  components: {mCard517, mA},
  props: {
    content: {}
  },
  computed: {
    ...CardComputed
  },
  mounted() {

  }

}
</script>

<style scoped>
.description-card{
  font-size: 0.875em;

}

.title-card{
  font-size: 19px;

}

.show-button-content-501{
  font-size: 15px;

}

.icon-show-content{
  font-size: 0.875em;

}

</style>